import {
    Component,
    Input,
    trigger,
    state,
    style,
    transition,
    keyframes,
    animate } from '@angular/core';

@Component({
    selector: 'itpx-tile',
    templateUrl: './tile.component.html',
    styleUrls: [ './tile.component.css' ],
    animations: [
        trigger('flyInOut', [
            state('in', style({})),
                transition('void => *', [
                animate(400, keyframes([
                    style({opacity: 1, height: '0', offset: 0}),
                    style({opacity: 1, height: '*', offset: 0}),
                    style({opacity: 1, transform: 'translateY(15px)',  offset: 0.3}),
                    style({opacity: 1, transform: 'translateY(0)',     offset: 1.0})
                ]))
            ])
        ])
    ]
})
export class TileComponent {
    @Input() routerLink: string;
    @Input() color: string;
    @Input() title: string;
    @Input() icon: string;
    @Input() description: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/components/tile/tile.component.ts